import type {
  PresetKey,
  TimeFilter,
} from "@/components/v2/DatePicker/constants";

import { createContext } from "react";
import type { DateRange } from "react-day-picker";

export type IHomePageContext = {
  dateRange?: DateRange;
  datePreset?: PresetKey;
  timeFilter?: TimeFilter;
  comparisonTimeFilter?: TimeFilter;
  selectedTenantCategoryIds: string[] | null;
};

export const HomePageContext = createContext({
  dateRange: undefined,
  datePreset: undefined,
  timeFilter: undefined,
  comparisonTimeFilter: undefined,
  selectedTenantCategoryIds: null,
} as IHomePageContext);
